import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcConnect = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M21.207 4.207a1 1 0 1 0-1.414-1.414l-2 2-.849-.848a2.75 2.75 0 0 0-3.889 0l-2.098 2.098a1 1 0 0 0 0 1.414l5.586 5.586a1 1 0 0 0 1.414 0l2.098-2.098a2.75 2.75 0 0 0 0-3.89l-.848-.848 2-2Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M10.957 11.457a1 1 0 0 0-1.414-1.414l-1.5 1.5-.586-.586a1 1 0 0 0-1.414 0l-2.098 2.098a2.75 2.75 0 0 0 0 3.89l.848.848-2 2a1 1 0 1 0 1.414 1.414l2-2 .848.848a2.75 2.75 0 0 0 3.89 0l2.098-2.098a1 1 0 0 0 0-1.414l-.586-.586 1.5-1.5a1 1 0 0 0-1.414-1.414l-1.5 1.5-1.586-1.586 1.5-1.5Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcConnect");

export { IcConnect };
//# sourceMappingURL=ic-connect.js.map
